module.exports = __webpack_public_path__ + "static/media/p4.7ce0f312.png";